module.exports = __webpack_public_path__ + "static/media/mapa_uberlandia_limpo.643671f3.png";